import { digitsFaToEn } from '@persian-tools/persian-tools';
import moment from 'moment-jalaali';

export function persianMonth(n: number) {
  let value = digitsFaToEn(moment(n).format('jM'));

  switch (value) {
    case '1':
      return 'فروردین';
    case '2':
      return 'اردیبهشت';
    case '3':
      return 'خرداد';
    case '4':
      return 'تیر';
    case '5':
      return 'مرداد';
    case '6':
      return 'شهریور';
    case '7':
      return 'مهر';
    case '8':
      return 'آبان';
    case '9':
      return 'آذر';
    case '10':
      return 'دی';
    case '11':
      return 'بهمن';
    case '12':
      return 'اسفند';
  }
}
